/**
 * Created by hernanherreros on 2019-05-06
 */

const DEV_HOST = 'https://trazoevents.com'
const PROD_HOST = window.location.protocol + '//' + window.location.hostname

export const isDev = process.env.NODE_ENV === 'development'

export const baseAPIRoot = isDev ? `${DEV_HOST}/api` : `${PROD_HOST}/api`

export const formsURL = isDev ? `${DEV_HOST}/forms` : `${PROD_HOST}/forms`

// Timer Settings
const MINUTES = 15
export const TIMER_MINUTES = MINUTES  * 60 * 1000
